
// NATIVE 


// INSTALLED 


// CUSTOM 
import { checkingPreload, unCheckingPreload } from '../loading';
import { uploadFileImageFromCameraService, uploadFileImageService, uploadFilePdfService } from '../../services/uploaders.service';




export const uploadPdfStore = ( code_file:string, file_rut:any, setPercentageUploadRut:any): any => {
    return async( dispatch: any ) => {

        dispatch( checkingPreload() );
        
        const result =  await uploadFilePdfService(code_file, file_rut, setPercentageUploadRut);

        dispatch( unCheckingPreload() );

        return result;
        
    }
}


export const uploadImgStore = ( code_file:string, file_rut:any, setPercentageUploadRut:any): any => {

    return async( dispatch: any ) => {

        dispatch( checkingPreload() );
        
        const result = await uploadFileImageService(code_file, file_rut, setPercentageUploadRut);

        dispatch( unCheckingPreload() );


        return result;
        
    }
}




export const uploadFileImageFromCamera = ( code_file:string, blob:any, setPercentageUpload:any): any => {

    return async( dispatch: any ) => {

        dispatch( checkingPreload() );
        
        const result = await uploadFileImageFromCameraService(code_file, blob, setPercentageUpload);

        dispatch( unCheckingPreload() );


        return result;
        
    }
}